import {StatusPill} from "@/components/statusPill/StatusPill.tsx";
import {PillStatus, StatusPillType, StatusPillVariant} from "@/components/statusPill/StatusPill.types.ts";
import {IncidentState} from "@/lib/types/statuspages.ts";

const IncidentStateMap: Record<IncidentState, PillStatus> = {
  [IncidentState.INVESTIGATION]: PillStatus.INVESTIGATING,
  [IncidentState.IDENTIFIED]: PillStatus.IDENTIFIED,
  [IncidentState.MONITORING]: PillStatus.MONITORING,
  [IncidentState.RESOLVED]: PillStatus.RESOLVED,
  [IncidentState.NOTIFICATION]: PillStatus.NOTIFICATION,
  [IncidentState.MAINTENANCE]: PillStatus.MAINTENANCE,
};

interface IncidentStateIconProps {
  state: IncidentState;
  className?: string;
  variant?: StatusPillVariant;
  type?: StatusPillType;
}

export const IncidentStateIcon = ({state, className, variant = "icon", type = "incident"}: IncidentStateIconProps) => {
  return <StatusPill type={type} variant={variant} status={IncidentStateMap[state]} className={className} />;
};
